import { ALL_VALUE, SEGMENT_FIELDS } from '../../constants';
import {
  INormalizedSegment,
  ISegment,
  ParserFunction,
  SegmentFieldsNames,
  SegmentValue
} from './types';

const getVip = (segmentValue: string | null | undefined) =>
  segmentValue?.length ? segmentValue : ALL_VALUE;

const getAllArray = (segmentValue: SegmentValue) =>
  segmentValue === ALL_VALUE ? ALL_VALUE : segmentValue;

const getBalance = (segmentValue: number | null) =>
  segmentValue !== null && segmentValue >= 0 ? segmentValue : ALL_VALUE;

const getBTAGArray = (segmentValue: string | null | undefined) =>
  segmentValue?.length ? segmentValue.split(',') : ALL_VALUE;

const getLanguages = (languages: string[] = [], segment = {} as ISegment) =>
  languages?.length && segment.showForLanguages !== 'allLanguages'
    ? segment.languages
    : ALL_VALUE;

const getCountries = (countries: string[] = [], segment = {} as ISegment) =>
  countries?.length && segment.showForCountries !== 'allCountries'
    ? segment.countries
    : ALL_VALUE;

const getAge = (segmentValue: number | null) =>
  segmentValue !== null && segmentValue >= 0 ? segmentValue : ALL_VALUE;

const getAccountVerified = (segmentValue: SegmentValue) =>
  segmentValue === null || segmentValue === undefined
    ? ALL_VALUE
    : segmentValue;

const getDeposit = (segmentValue: string | null | undefined) =>
  segmentValue?.length ? segmentValue : ALL_VALUE;

const getGroup = (segmentValue: string | null | undefined) =>
  segmentValue?.length ? segmentValue : ALL_VALUE;

const parsersMap = {
  [SEGMENT_FIELDS.USER_DEPOSITED]: getDeposit,
  [SEGMENT_FIELDS.BALANCE_FROM]: getBalance,
  [SEGMENT_FIELDS.BALANCE_TO]: getBalance,
  [SEGMENT_FIELDS.USER_GROUP]: getAllArray,
  [SEGMENT_FIELDS.REGISTRATION]: getAllArray,
  [SEGMENT_FIELDS.VIP]: getVip,
  [SEGMENT_FIELDS.AFFILIATE_ID]: getBTAGArray,
  [SEGMENT_FIELDS.CREATIVE_ID]: getBTAGArray,
  [SEGMENT_FIELDS.SITE_TRACKER_ID]: getBTAGArray,
  [SEGMENT_FIELDS.ANID_ZONE_ID]: getBTAGArray,
  [SEGMENT_FIELDS.LANGUAGES]: getLanguages,
  [SEGMENT_FIELDS.COUNTRIES]: getCountries,
  [SEGMENT_FIELDS.AGE_FROM]: getAge,
  [SEGMENT_FIELDS.AGE_TO]: getAge,
  [SEGMENT_FIELDS.ACCOUNT_VERIFIED]: getAccountVerified,
  [SEGMENT_FIELDS.GROUP]: getGroup
} as const;

const normalizeSegments = (segments: ISegment[] = []) =>
  segments.map((segment) => {
    const { id, segmentName, showForLanguages, showForCountries, ...rest } =
      segment;
    const parsedSegment: INormalizedSegment = {
      // tech values, them not compare with filter
      techFields: {
        showForLanguages,
        showForCountries,
        segmentName,
        id
      }
    };

    for (const key of Object.keys(rest) as Array<SegmentFieldsNames>) {
      const parser = parsersMap[key] as ParserFunction | undefined;

      if (parser) {
        const parsedValue = parser(segment[key] as SegmentValue, segment);

        if (parsedValue !== ALL_VALUE) {
          // TODO: investigate why getting error here
          // @ts-expect-error getting an error, all variables types are defined though
          parsedSegment[key as SegmentFieldsNames] = parsedValue;
        }
      }
    }

    return parsedSegment;
  });

export default normalizeSegments;
